import React, { useState } from 'react';
import { Stack } from 'library/ui';
import { AvailableTeacher } from 'models';
import { UpperDaysOfWeek } from 'shared/Dates';
import { usePostJobNavigation } from 'parent-portal/jobs/postJob/usePostJobNavigation';
import moment from 'moment-timezone';
import AvailableTeacherCard from './AvailableTeacherCard';
import EditOrCreateNewJobModal from './EditOrCreateNewJobModal';
import { teacherToSpotlightWorkerApiObject } from './inviteUtils';

export default function AvailableTeachersList({ teachers }: { teachers: AvailableTeacher[] }) {
    const [inviteModalOpen, setInviteModalOpen] = useState(false);
    const [selectedWorker, setSelectedWorker] = useState<AvailableTeacher[]>([]);
    const [selectedTimeslot, setSelectedTimeslot] = useState<{ upper: string; lower: string; timezone: string }>();

    const { goToPostJob } = usePostJobNavigation();

    function openInviteModal(teacher: AvailableTeacher, lower: string, upper: string, timezone?: string) {
        setSelectedWorker([teacher]);
        setSelectedTimeslot({ lower, upper, timezone: timezone ?? 'America/New_York' });
        setInviteModalOpen(true);
    }

    function closeAndReset() {
        setInviteModalOpen(false);
        setSelectedWorker([]);
        setSelectedTimeslot(undefined);
    }

    function request() {
        if (!selectedTimeslot || selectedWorker.length === 0) {
            return;
        }
        const formattedWorker = teacherToSpotlightWorkerApiObject(selectedWorker[0]);

        setSelectedWorker([]);

        const start = moment.tz(selectedTimeslot.lower, selectedTimeslot.timezone);
        const end = moment.tz(selectedTimeslot.upper, selectedTimeslot.timezone);
        goToPostJob('Available Teachers', {
            spotlightWorkers: [
                { id: formattedWorker.id, name: formattedWorker.name, pictureUrl: formattedWorker.pictureUrl },
            ],
            startDate: start.format('YYYY-MM-DD'),
            endDate: end.format('YYYY-MM-DD'),
            days: [start.format('dddd') as UpperDaysOfWeek],
            times: { start: start.format('HH:mm:ss'), end: end.format('HH:mm:ss') },
        });
    }

    return (
        <Stack gap="md">
            {teachers.map((teacher) => (
                <AvailableTeacherCard key={teacher.id} teacher={teacher} requestToBook={openInviteModal} />
            ))}
            <EditOrCreateNewJobModal
                open={inviteModalOpen}
                onClose={closeAndReset}
                selectedWorkers={selectedWorker}
                openJobForm={request}
            />
        </Stack>
    );
}
